module.exports = __webpack_public_path__ + "static/img/P10.ac69abed.png";